import React, { useState } from 'react'
import NewActionMenu from 'components/ContentBox/Global/ActionMenu/ActionMenu'
import styles from './RowDiscipline.module.scss'
import ActionMenu from 'components/UI/ActionMenu/ActionMenu'

const RowDiscipline = ({ level, index, action }) => {
  const [expanded, setExpanded] = useState(false)

  const toggleExpand = () => {
    setExpanded(!expanded)
  }

  const menu = [
    { name: 'Edit', action: 'edit' },
    { name: 'Delete', action: 'delete' },
  ]

  return (
    <>
      <div
        className={`${styles.clientContainer} ${index % 2 === 0 ? styles.colorBg : ''} ${expanded && styles.colorBgActive}`}
      >
        <div className={styles.containerInf}>
          <div
            className={`${styles.infStyl} ${styles.name} ${expanded ? styles.expClr : styles.notExpClr}`}
          >
            {level.name}
          </div>
          <div className={styles.buttons}>
            <NewActionMenu variant='simple' onSimpleAction={toggleExpand} />
            <ActionMenu menu={menu} action={action} items={level} />
          </div>
        </div>
      </div>
      {expanded && (
        <div className={styles.clientDetails}>
          <div className={`${styles.formField} `}>
            <div className={styles.label}>Discipline:</div>
            <div className={styles.info}>{level.name}</div>
          </div>
        </div>
      )}
    </>
  )
}

export default RowDiscipline
